import { customAlphabet } from 'nanoid';

export const generateHumanCode = (length: number) => {
  const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', length);
  return nanoid();
}